






























































































import { Component, Vue } from 'vue-property-decorator';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import { required, numeric, min, max } from 'vee-validate/dist/rules';
import { params } from 'vee-validate/dist/types/rules/alpha';
import Swal from 'sweetalert2';

extend('required', required);
extend('numeric', numeric);
extend('min', min);
extend('max', max);

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
  },
})
export default class Receiver extends Vue {
    private errors = [];
    private valid = '';
    private contactId = '';
    private dirtyForm = false;
    private form = {
      id: null,
      name: null,
      tel: null,
      address: null,
    };
    private pdfOptions = {
        'A4': 'A4',
        '10x10': '2.5"x4.0"',
    };

    private created() {
        this.contactId = this.$route.params.id;
        if (this.contactId) {
            this.getContactInfo();
        }
    }

    private getContactInfo() {
      this.$http.get(`/api/address/${this.contactId}`).then((response: any) => {
        this.form = response.data;
      }, (err: any) => {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then((result) => {
                // error case
            });
      });
    }

    private submitContact() {
        if (this.contactId === undefined) {
            this.$http.post(`/api/address/delivery`, this.form).then((response: any) => {
                Swal.fire({
                allowOutsideClick: false,
                title: 'บันทึกข้อมูลสำเร็จ',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
                }).then((result) => {
                    if (result.value) {
                        this.$router.push({ name: 'contact' });
                    }
                });
            }, (err: any) => {
                Swal.fire({
                    title: 'เกิดข้อผิดพลาด',
                    focusConfirm: false,
                    focusCancel: false,
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#ec1b23',
                }).then((result) => {
                    // error case
                });
            });
        } else if (this.contactId !== undefined) {
            Swal.fire({
                title: 'เลือกขนาดใบจ่าหน้า',
                input: 'radio',
                inputOptions: this.pdfOptions,
                focusConfirm: false,
                confirmButtonText: 'ยืนยัน',
                confirmButtonColor: '#ec1b23',
                preConfirm: (value) => {
                    if (value) {
                        return new Promise((resolve) =>  {
                            resolve();
                        });
                    } else {
                        return false;
                    }
                },
            }).then((result) => {
                if (result.value) {
                    this.submitGeneratePdf(result.value);
                }
            });
        }
    }

    private submitGeneratePdf(pdfSize: any) {
        Swal.fire({
          title: 'ระบบกำลังดำเนินการ<br />สร้างใบจ่าหน้า',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        this.$http.post(`/api/address/delivery-gen-pdf/${pdfSize}`, this.form).then((response: any) => {
            if (response.body.task === 'SendPdf') {
                const taskBody = JSON.parse(response.body.message);
                if (taskBody.link != null) {
                    Swal.fire({
                        allowOutsideClick: false,
                        title: 'สร้างใบจ่าหน้าสำเร็จ',
                        focusConfirm: false,
                        focusCancel: false,
                        showCancelButton: true,
                        confirmButtonText: 'ดาวน์โหลด',
                        confirmButtonColor: '#ec1b23',
                        cancelButtonText: 'ปิด',
                    }).then((result) => {
                        if (this.dirtyForm) {
                            this.saveUpdateContact();
                        }
                        if (result.value) {
                            window.open(`${taskBody.link}?openExternalBrowser=1`);
                            this.$router.push({ name: 'contact' });
                        } else {
                            this.$router.push({ name: 'contact' });
                        }
                    });
                } else {
                     Swal.fire({
                        title: 'สร้างใบจ่าหน้าไม่สำเร็จ',
                        text: 'ไม่สามารถสร้างใบจ่าหน้าได้เพราะไม่พบรหัสไปรษณีย์ กรุณาลองอีกครั้ง',
                        focusConfirm: false,
                        focusCancel: false,
                        confirmButtonText: 'ตกลง',
                        confirmButtonColor: '#ec1b23',
                    }).then();
                }
            } else {
                Swal.fire({
                    title: 'ไม่สามารถทำรายการได้ในขณะนี้',
                    text: 'กรุณาลองอีกครั้ง',
                    focusConfirm: false,
                    focusCancel: false,
                    confirmButtonText: 'ตกลง',
                    confirmButtonColor: '#ec1b23',
                }).then();
            }
        }, (err: any) => {
          if (err.status === 504) {
            Swal.fire({
                title: 'ระบบกำลังดำเนินการ<br />สร้างใบจ่าหน้า',
                html: 'ตรวจสอบได้ที่ประวัติใบจ่าหน้า',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then();
          } else {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then();
          }
        });
    }

    private saveUpdateContact() {
        this.$http.put(`/api/address/${this.contactId}`, this.form).then((response: any) => {
            this.$router.push({ name: 'contact' });
        }, (err: any) => {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then();
        });
    }

    private deleteContact() {
        Swal.fire({
            title: 'ต้องการลบรายชื่อนี้ใช่หรือไม่',
            text: 'หากยืนยันการลบแล้วข้อมูลจะไม่สามารถกู้คืนได้',
            showCancelButton: true,
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก',
            confirmButtonColor: '#ec1b23',
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                this.confirmedDelete();
            }
        });
    }

    private confirmedDelete() {
        this.$http.delete(`/api/address/${this.contactId}`).then((response: any) => {
            Swal.fire({
                allowOutsideClick: false,
                title: 'ลบข้อมูลสำเร็จ',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then((result) => {
                if (result.value) {
                    this.$router.push({ name: 'contact' });
                }
            });
        }, (err: any) => {
            Swal.fire({
                title: 'เกิดข้อผิดพลาด',
                focusConfirm: false,
                focusCancel: false,
                confirmButtonText: 'ตกลง',
                confirmButtonColor: '#ec1b23',
            }).then();
        });
    }
}
